import React from 'react';
import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const DashboardIcon = ({ width = 26, height = 22, color: colorProp, fill: fillProp, hovered }: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProp || defaultColor;
  const fill = fillProp || defaultFill;
  return (
    <svg width={width} height={height} viewBox='0 0 26 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M23.4516 21H2.54839C1.69677 21 1 20.3571 1 19.5714V2.42857C1 1.64286 1.69677 1 2.54839 1H23.4516C24.3032 1 25 1.64286 25 2.42857V19.5714C25 20.3571 24.3032 21 23.4516 21Z'
        fill='white'
      />
      {hovered && (
        <>
          <rect x='1.29736' y='1.2959' width='11.7025' height='9.70363' fill={fill} />
          <rect x='13' y='11' width='11.7695' height='9.74683' fill={fill} />
        </>
      )}
      <path
        d='M23.4516 21H2.54839C1.69677 21 1 20.3571 1 19.5714V2.42857C1 1.64286 1.69677 1 2.54839 1H23.4516C24.3032 1 25 1.64286 25 2.42857V19.5714C25 20.3571 24.3032 21 23.4516 21Z'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.31055 7.58647L4.52151 6.31611L6.33795 8.85683L8.75987 3.77539L10.5763 7.58647H11.2402'
        stroke={color}
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M14.7598 3.77051V8.8096' stroke={color} strokeWidth='1.2' strokeLinecap='round' />
      <line x1='18.6933' y1='5.69375' x2='18.6933' y2='8.8763' stroke={color} strokeWidth='1.2' strokeLinecap='round' />
      <line
        x1='22.6933'
        y1='4.18301'
        x2='22.6933'
        y2='8.87642'
        stroke={color}
        strokeWidth='1.2'
        strokeLinecap='round'
      />
      <path d='M3.31055 13.1143L3.31055 18.1534' stroke={color} strokeWidth='1.2' strokeLinecap='round' />
      <line x1='7.24404' y1='15.0375' x2='7.24404' y2='18.22' stroke={color} strokeWidth='1.2' strokeLinecap='round' />
      <line x1='11.244' y1='13.5268' x2='11.244' y2='18.2202' stroke={color} strokeWidth='1.2' strokeLinecap='round' />
      <path
        d='M14.7598 16.8833L15.9707 15.613L17.7872 18.1537L20.2091 13.0723L22.0255 16.8833H22.6895'
        stroke={color}
        strokeWidth='1.2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
